export const DATE_FORMAT_V1 = 'DD/MM/YYYY';
export const DATE_FORMAT_24h = 'DD/MM/yyyy hh:mm';
export const DATE_FORMAT_12H = 'DD/MM/YYYY, HH:mm A';
export const TIME_FORMAT = 'HH:mm';
